<div class="page-footer">
	<div class="container bottom-group">
		<div class="flex-box">
			<div #footerCopyright class="text"></div>
		</div>
		<div class="disclaimers">
			<div class="disclaimer-content">
				<p><sup>*</sup>Price Promotions - Due to manufacturer restrictions, select new release and other specified
					products are excluded from price promotions. Additionally, there are restrictions on the use of
					coupon&nbsp;codes.</p>
			</div>
			<div class="disclaimer-content">
				<p>If you are using a screen reader or other assistive technology and are having problems using this website,
					or if you have any other difficulties accessing this website, please call <a href="tel:{{phoneNumber}}"
																								 id="phoneNumberLink" class="">{{phoneNumber}}</a></p>
			</div>
		</div>
		<ul id="footer-links" class="bottom-group__list flex-box">
			<li class="bottom-group__item"><a href="/s/terms-of-use"
											  class="text text--listed-link">Terms of Use</a></li>
			<li class="bottom-group__item"><a href="/s/web-content-accessibility-policy"
											  class="text text--listed-link">Accessibility Policy</a></li>
			<li class="bottom-group__item"><a href="/s/california-disclosures"
											  class="text text--listed-link">California Disclosures</a></li>
			<li class="bottom-group__item"><a href="/s/privacy-policy"
											  class="text text--listed-link">Privacy Policy</a></li>
			<li class="bottom-group__item"><a href="/s/donotsell"
											  class="text text--listed-link">Your Privacy Choices</a></li>
		</ul>
	</div>
</div>
